// Source: https://github.com/admirhodzic/multiselect-dropdown

var style = document.createElement("style");
style.setAttribute("id", "multiselect_dropdown_styles");
style.innerHTML = `
.multiselect-dropdown {
  display: inline-block;
  padding: 2px 5px 0px 5px;
  border-radius: 4px;
  border: solid 1px #ced4da;
  background-color: white;
  position: relative;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right .75rem center;
  background-size: 16px 12px;
}
.multiselect-dropdown span.optext, .multiselect-dropdown .placeholder {
  margin-right:0.5em;
  margin-bottom:2px;
  padding:1px 0;
  border-radius: 4px;
  display:inline-block;
}
.multiselect-dropdown span.optext {
  background-color:lightgray;
  padding:1px 0.75em;
}
.multiselect-dropdown span.optext .optdel {
  float: right;
  margin: 0 -6px 1px 5px;
  font-size: 0.7em;
  margin-top: 2px;
  cursor: pointer;
  color: #666;
}
.multiselect-dropdown span.optext .optdel:hover { color: #c66;}
.multiselect-dropdown .placeholder{
  color:#ced4da;
}
.multiselect-dropdown-list-wrapper {
  box-shadow: gray 0 3px 8px;
  z-index: 100;
  padding: 2px;
  border-radius: 4px;
  border: solid 1px #ced4da;
  display: none;
  margin: -1px;
  position: absolute;
  top: 37px;
  left: 0;
  right: 0;
  background: white;
}
.multiselect-dropdown-list-wrapper .multiselect-dropdown-search {
  margin-bottom: 5px;
}
.multiselect-dropdown-list {
  padding:2px;
  min-height: 5rem;
  overflow-y:auto;
  overflow-x: hidden;
}
.multiselect-dropdown-list::-webkit-scrollbar {
  width: 6px;
}
.multiselect-dropdown-list::-webkit-scrollbar-thumb {
  background-color: #bec4ca;
  border-radius:3px;
}
.multiselect-dropdown-list div {
  padding: 5px;
}
.multiselect-dropdown-list input {
  height: 1.15em;
  width: 1.15em;
  margin-right: 0.35em;
}
.multiselect-dropdown-list label {
    pointer-events: none;
}
.multiselect-dropdown-list input:focus {
  outline: solid 2px #000;
}
.multiselect-dropdown-list div.checked {
}
.multiselect-dropdown-list div:hover {
  background-color: #ced4da;
}
.multiselect-dropdown span.maxselected {
    width:100%;
}
.multiselect-dropdown-all-selector {
    border-bottom:solid 1px #999;
}

.multiselect-dropdown-fieldset {
    width: 100%;
    border: 0;
}
`;
document.head.appendChild(style);

function MultiselectDropdown(options) {
    var config = {
        search: true,
        height: "15rem",
        placeholder: "select",
        txtSelected: "Vald",
        txtAll: "Alla",
        txtRemove: "Ta bort",
        txtSearch: "Sök",
        ...options,
    };
    function newEl(tag, attrs) {
        var e = document.createElement(tag);
        if (attrs !== undefined)
            Object.keys(attrs).forEach((k) => {
                if (k === "class" && attrs[k].includes(",")) {
                    attrs[k] = attrs[k].split(",");
                }
                if (k === "class") {
                    Array.isArray(attrs[k])
                        ? attrs[k].forEach((o) => (o !== "" ? e.classList.add(o) : 0))
                        : attrs[k] !== ""
                          ? e.classList.add(attrs[k])
                          : 0;
                } else if (k === "style") {
                    Object.keys(attrs[k]).forEach((ks) => {
                        e.style[ks] = attrs[k][ks];
                    });
                } else if (k === "text") {
                    attrs[k] === "" ? (e.innerHTML = "&nbsp;") : (e.innerText = attrs[k]);
                } else if (k === "for") {
                    e.setAttribute("for", attrs[k]);
                } else if (k === "ariaLabelledBy") {
                    e.setAttribute("aria-labelledby", attrs[k]);
                } else e[k] = attrs[k];
            });
        return e;
    }

    document.querySelectorAll("select[multiple]").forEach((el, k) => {
        var fieldset = newEl("fieldset", {
            class: "multiselect-dropdown-fieldset",
        });
        var div = newEl("div", {
            class: "multiselect-dropdown",
            style: {
                width: config.style?.width ?? el.clientWidth + "px",
                padding: config.style?.padding ?? "",
            },
            tabIndex: "0",
        });
        fieldset.appendChild(div);
        div.setAttribute("aria-expanded", "false");
        el.style.display = "none";
        el.parentNode.insertBefore(fieldset, el.nextSibling);

        var listWrap = newEl("div", {
            class: "multiselect-dropdown-list-wrapper",
        });
        var list = newEl("div", {
            class: "multiselect-dropdown-list",
            style: { maxHeight: config.height },
        });
        var search = newEl("input", {
            class: ["multiselect-dropdown-search"].concat([config.searchInput?.class ?? "form-control"]),
            style: {
                width: "100%",
                display: el.attributes["multiselect-search"]?.value === "true" ? "block" : "none",
            },
            placeholder: config.txtSearch,
        });
        listWrap.appendChild(search);
        div.appendChild(listWrap);
        listWrap.appendChild(list);

        el.loadOptions = () => {
            list.innerHTML = "";

            if (el.attributes["multiselect-select-all"]?.value == "true") {
                const op = newEl("div", {
                    class: "multiselect-dropdown-all-selector",
                });
                const rand = Math.floor(Math.random() * 100000); // Add random number to checkbox id to avoid duplicate ids
                const ic = newEl("input", {
                    type: "checkbox",
                    disabled: op.classList.contains("empty"),
                    id: rand + "-all-checkbox",
                    ariaLabelledBy: rand + "-all-label",
                });
                op.appendChild(ic);
                op.appendChild(
                    newEl("label", { text: config.txtAll, for: rand + "-all-checkbox", id: rand + "-all-label" }),
                );

                op.addEventListener("click", () => {
                    op.classList.toggle("checked");
                    op.querySelector("input").checked = !op.querySelector("input").checked;

                    var ch = op.querySelector("input").checked;
                    list.querySelectorAll(":scope > div:not(.multiselect-dropdown-all-selector)").forEach((i) => {
                        if (i.style.display !== "none") {
                            i.querySelector("input").checked = ch;
                            i.optEl.selected = ch;
                        }
                    });

                    el.dispatchEvent(new Event("change"));
                });
                ic.addEventListener("click", (ev) => {
                    ic.checked = !ic.checked;
                });

                list.appendChild(op);
            }

            Array.from(el.options).map((o) => {
                const op = newEl("div", {
                    class: (o.selected ? "checked" : "") + (o.classList.length > 0 ? o.classList.value.split(" ") : ""),
                    optEl: o,
                });

                const rand = Math.floor(Math.random() * 100000); // Add random number to checkbox id to avoid duplicate ids
                const ic = newEl("input", {
                    type: "checkbox",
                    checked: o.selected,
                    disabled: op.classList.contains("empty"),
                    id: rand + "-" + o.value + "-checkbox",
                    ariaLabelledBy: rand + "-" + o.value + "-label",
                });
                op.appendChild(ic);
                op.appendChild(
                    newEl("label", {
                        text: o.text,
                        for: rand + "-" + o.value + "-checkbox",
                        id: rand + "-" + o.value + "-label",
                    }),
                );

                op.addEventListener("click", () => {
                    op.classList.toggle("checked");
                    op.querySelector("input").checked = !op.querySelector("input").checked;
                    op.optEl.selected = !op.optEl.selected;
                    el.dispatchEvent(new Event("change"));
                });
                ic.addEventListener("click", (ev) => {
                    ic.checked = !ic.checked;
                });
                o.listitemEl = op;
                list.appendChild(op);
            });
            div.listEl = listWrap;

            div.refresh = () => {
                div.querySelectorAll("span.optext, .placeholder").forEach((t) => div.removeChild(t));
                var sels = Array.from(el.selectedOptions);
                if (sels.length > (el.attributes["multiselect-max-items"]?.value ?? 5)) {
                    div.appendChild(
                        newEl("span", {
                            class: ["optext", "maxselected"],
                            text: sels.length + " " + config.txtSelected,
                        }),
                    );
                } else {
                    sels.map((x) => {
                        var c = newEl("span", {
                            class: "optext",
                            text: x.text,
                            srcOption: x,
                        });
                        if (el.attributes["multiselect-hide-x"]?.value !== "true")
                            c.appendChild(
                                newEl("span", {
                                    class: "optdel",
                                    text: "🗙",
                                    title: config.txtRemove,
                                    onclick: (ev) => {
                                        c.srcOption.listitemEl.dispatchEvent(new Event("click"));
                                        div.refresh();
                                        ev.stopPropagation();
                                    },
                                }),
                            );

                        div.appendChild(c);
                    });
                }
                if (0 == el.selectedOptions.length)
                    div.appendChild(
                        newEl("legend", {
                            class: "placeholder",
                            text: el.attributes["placeholder"]?.value ?? config.placeholder,
                        }),
                    );
            };
            div.refresh();
        };
        el.loadOptions();

        search.addEventListener("input", () => {
            list.querySelectorAll(":scope div:not(.multiselect-dropdown-all-selector)").forEach((d) => {
                var txt = d.querySelector("label").innerText.toUpperCase();
                d.style.display = txt.includes(search.value.toUpperCase()) ? "block" : "none";
            });
        });

        div.addEventListener("click", () => {
            div.setAttribute("aria-expanded", "true");
            div.listEl.style.display = "block";
            search.focus();
            search.select();
        });
        div.addEventListener("keyup", function (event) {
            if (event.key === "Enter") {
                div.listEl.style.display = "block";
                search.focus();
                search.select();
            }
            if (event.keyCode == 27) {
                div.listEl.style.display = "none";
                div.focus();
            }
        });

        document.addEventListener("click", function (event) {
            if (!div.contains(event.target)) {
                listWrap.style.display = "none";
                div.setAttribute("aria-expanded", "false");
                div.refresh();
            }
        });
    });
}

window.addEventListener("load", () => {
    MultiselectDropdown(window.MultiselectDropdownOptions);
});
